var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Tooltip",
    {
      attrs: {
        placement: "left",
        variant: _vm.TooltipVariants.DARK,
        tooltipContainerClasses: "ml-90% w-full",
        tooltipClasses: "w-60",
        trigger: "hover click",
      },
      scopedSlots: _vm._u([
        {
          key: "content",
          fn: function () {
            return [
              _c(
                "div",
                [
                  _c("div", { staticClass: "text-center" }, [
                    _vm.isRequested
                      ? _c("p", [
                          _vm._v(
                            "You have requested access to the public Marketplace"
                          ),
                        ])
                      : _c("p", [
                          _vm._v(
                            "The public Marketplace is disabled by company admin"
                          ),
                        ]),
                  ]),
                  _c("UiButton", {
                    staticClass: "mb-1",
                    attrs: {
                      buttonText: _vm.marketplaceRequestOptions.buttonText,
                      buttonClasses: "h-9 w-full",
                      variant: "secondary",
                      size: "no",
                      processing: _vm.processing,
                    },
                    on: { click: _vm.marketplaceRequestOptions.action },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("SidebarItem", {
        attrs: {
          title: _vm.sidebarItem.title,
          icon: _vm.sidebarItem.icon,
          routeParams: _vm.sidebarItem.slug,
          disabled: "",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }